export class UserFacingError extends Error {
  readonly userFacing = true

  constructor(message: string) {
    super(message)
    this.name = 'UserFacingError'
  }
}
